import { Button } from "@/components/ui/button";
import { useDiaryByIdQuery } from "@/features/diaries/api";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "@tanstack/react-router";
import { RefreshCw } from "lucide-react";

interface NoDiarySelectedProps {
	diaryId?: string;
}

const NoDiarySelected = ({ diaryId }: NoDiarySelectedProps) => {
	const queryClient = useQueryClient();
	const router = useRouter();
	const { refetch: refetchDiary, isFetching } = useDiaryByIdQuery(
		diaryId ?? "",
	);

	const handleRefresh = async () => {
		// Reset all queries to ensure fresh data
		queryClient.resetQueries();
		await refetchDiary();
		router.invalidate();
	};

	return (
		<div className="flex flex-col justify-center items-center gap-4 my-8 w-full h-full">
			<div className="dark:text-slate-200 text-xl">No Diary Selected</div>
			{diaryId && (
				<Button
					variant="outline"
					size="sm"
					onClick={handleRefresh}
					className="flex items-center gap-2"
					disabled={isFetching}
				>
					<RefreshCw
						className={`h-4 w-4 ${isFetching ? "animate-spin" : ""}`}
					/>
					Refresh Diary
				</Button>
			)}
		</div>
	);
};

export default NoDiarySelected;
